import Papaparse from 'papaparse';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { reduxForm } from 'redux-form';
import { t } from '../../../../../modules/infra/i18n';

import { getShopBarbers } from '../../reducers';
import withNotifications from '../../../../common/withNotifications';
import { prepareMinsForSaving } from '../../../../common/helpers/schedules';
import {
  customersImport,
  deleteImportedCustomers,
  deleteAllCustomers,
} from '../../actions';
import confirmModal from '../../../../common/confirmModal';

const mapStateToProps = (state, props) => ({
  barbers: getShopBarbers(state, props.params.id),
});

const mapDispatchToProps = {
  customersImport,
  deleteImportedCustomers,
  deleteAllCustomers,
};

const initialValues = {
  barberReminderEmail: true,
  barberReminderPush: false,
  barberReminderTime: {
    hours: 24,
    minutes: 0,
  },
  reminderEmail: true,
  reminderPhone: true,
  reminderPush: true,
  reminderTime: {
    hours: 1,
    minutes: 0,
  },
};

const enhance = compose(
  reduxForm({ form: 'customerImport', initialValues }),
  connect(mapStateToProps, mapDispatchToProps),
  withState('preview', 'setPreview', false),
  withNotifications,
  withHandlers({
    onChange: props => (file) => {
      Papaparse.parse(file, {
        header: true,
        preview: 100,
        complete: (results) => {
          props.setPreview(results);
        },
      });
    },
    deleteImportedCustomers: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:import.customers.delete_imported.modal_title'),
        message: t('admin:import.customers.delete_imported.modal_message'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteImportedCustomers(props.params.id).then(response => props.addNotification({
        level: 'success',
        message: response.message,
        autoDismiss: 20,
        title: t('admin:import.customers.success_title'),
      }));
    },
    deleteAllCustomers: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:import.customers.delete_all.modal_title'),
        message: t('admin:import.customers.delete_all.modal_message'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteAllCustomers(props.params.id).then(response => props.addNotification({
        level: 'success',
        message: response.message,
        autoDismiss: 20,
        title: t('admin:import.customers.success_title'),
      }));
    },
    onSubmit: props => (model) => {
      const { time, csv, barberId, ...other } = model;

      if (!csv) {
        return props.addNotification({
          level: 'error',
          message: t('admin:import.customers.no_csv_file_error'),
          title: t('admin:import.customers.notification_title'),
          autoDismiss: 5,
        });
      }

      const data = Object.assign({}, other, {
        file: csv[0] || csv, // there's a FileList in chromium and just File in WebKit
        reminderTime: prepareMinsForSaving(time),
      });

      return props.customersImport(props.params.id, barberId, data)
        .then((res) => {
          props.change('csv', null);
          props.setPreview(false);
          props.addNotification({
            level: 'success',
            message: res.message,
            title: t('admin:import.customers.notification_title'),
            autoDismiss: 15,
          });

          return res;
        });
    },
  })
);

export default enhance;
